import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });

        // Log error to console (could be extended to send to logging service)
        console.error('ErrorBoundary caught an error:', error, errorInfo);
    }

    handleRetry = () => {
        this.setState({ hasError: false, error: null, errorInfo: null });
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '400px',
                    padding: '40px',
                    textAlign: 'center',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px',
                    margin: '20px'
                }}>
                    <div style={{
                        fontSize: '48px',
                        marginBottom: '20px'
                    }}>
                        ⚠️
                    </div>
                    <h2 style={{
                        color: '#333',
                        marginBottom: '10px'
                    }}>
                        Något gick fel
                    </h2>
                    <p style={{
                        color: '#666',
                        marginBottom: '20px',
                        maxWidth: '400px'
                    }}>
                        Ett oväntat fel uppstod. Prova att ladda om sidan eller gå tillbaka till startsidan.
                    </p>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button
                            onClick={this.handleRetry}
                            style={{
                                padding: '10px 20px',
                                backgroundColor: '#0c4da2',
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                fontSize: '14px'
                            }}
                        >
                            Försök igen
                        </button>
                        <button
                            onClick={() => window.location.href = '/'}
                            style={{
                                padding: '10px 20px',
                                backgroundColor: '#6c757d',
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                fontSize: '14px'
                            }}
                        >
                            Till startsidan
                        </button>
                    </div>
                    {process.env.NODE_ENV !== 'production' && this.state.error && (
                        <details style={{
                            marginTop: '30px',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            padding: '15px',
                            borderRadius: '5px',
                            border: '1px solid #ddd',
                            maxWidth: '600px',
                            overflow: 'auto'
                        }}>
                            <summary style={{ cursor: 'pointer', color: '#666' }}>
                                Teknisk information (endast dev)
                            </summary>
                            <pre style={{
                                marginTop: '10px',
                                fontSize: '12px',
                                color: '#c00',
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word'
                            }}>
                                {this.state.error.toString()}
                                {this.state.errorInfo?.componentStack}
                            </pre>
                        </details>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
